module.exports = __webpack_public_path__ + "img/Differentiation-OVCA_10X_OC.1fff2ac0.png";